module.exports = __webpack_public_path__ + "img/default.f6ef4ae2.png";